import { CommonModule, registerLocaleData } from '@angular/common';
import localeEsPe from '@angular/common/locales/es-PE';
import { NgModule } from '@angular/core';
import { AlertModule } from '@pacifico/components/alert/alert.module';
import { ButtonsReportsComponent } from '@pacifico/components/buttons-reports/buttons-reports.component';
import { CardAmountComponent } from '@pacifico/components/card-amount/card-amount.component';
import { CardSingleComponent } from '@pacifico/components/card-single/card-single.component';
import { ConfirmTransactionComponent } from '@pacifico/components/confirm-transaction/confirm-transaction.component';
import { FirtsStepComponent } from '@pacifico/components/firts-step/firts-step.component';
import { FloatingBarComponent } from '@pacifico/components/floating-bar/floating-bar.component';
import { InputMountComponent } from '@pacifico/components/input-mount/input-mount.component';
import { InputNumericComponent } from '@pacifico/components/input-numeric/input-numeric.component';
import { PaginatorComponent } from '@pacifico/components/paginator/paginator.component';
import { ProgressBarComponent } from '@pacifico/components/progress-bar/progress-bar.component';
import { ProgressStepsBarComponent } from '@pacifico/components/progress-steps-bar/progress-steps-bar.component';
import { SaveFrequentOperationComponent } from '@pacifico/components/save-frequent-operation/save-frequent-operation.component';
import { SelectAccountComponent } from '@pacifico/components/select-account/select-account.component';
import { StepperComponent } from '@pacifico/components/stepper/stepper.component';
import { StepperLimitsComponent } from '@pacifico/components/stepper_limits/stepper_limits.component';
import { StepperPhoneEmailComponent } from '@pacifico/components/stepper_phone_email/stepper_phone_email.component';
import { TableActionComponent } from '@pacifico/components/table-action/table-action.component';
import { TableBasicComponent } from '@pacifico/components/table-basic/table-basic.component';
import { TabComponent } from '@pacifico/components/tabs/tab/tab.component';
import { TabsComponent } from '@pacifico/components/tabs/tabs.component';
import { TagAccountTransferComponent } from '@pacifico/components/tag-account-transfer/tag-account-transfer.component';
import { TagMountComponent } from '@pacifico/components/tag-mount/tag-mount.component';
import { TagSmallComponent } from '@pacifico/components/tag-small/tag-small.component';
import { ToggleTabComponent } from '@pacifico/components/toggle-tab/toggle-tab.component';
import { ValidMessageFormComponent } from '@pacifico/components/valid-message-form/valid-message-form.component';
import { ValidTokenEmailComponent } from '@pacifico/components/valid-token-email/valid-token-email.component';
import { ValidTokenOnlyEmailComponent } from '@pacifico/components/valid-token-only-email/valid-token-only-email.component';
import { ValidTokenPhoneComponent } from '@pacifico/components/valid-token-phone/valid-token-phone.component';
import { ValidTokenPreferencesComponent } from '@pacifico/components/valid-token-preferences/valid-token-preferences.component';
import { ValidTokenComponent } from '@pacifico/components/valid-token/valid-token.component';
import { VoucherErrorComponent } from '@pacifico/components/voucher-error/voucher-error.component';
import { VoucherSuccessComponent } from '@pacifico/components/voucher-success/voucher-success.component';
import { AlphanumericDirective } from '@pacifico/directives/alphanumeric.directive';
import { NumericDirective } from '@pacifico/directives/numeric.directive';
import { SharedFormModule } from './shared-forms.module';
import { AlphaSpecialDirective } from '@pacifico/directives/alphaSpecial.directive';
import { AlphaSpecialPasswordDirective } from '@pacifico/directives/alphaSpecialPassword.directive';

registerLocaleData(localeEsPe);
@NgModule({
	declarations: [
		ToggleTabComponent,
		ButtonsReportsComponent,
		TableActionComponent,
		CardAmountComponent,
		TableBasicComponent,
		CardSingleComponent,
		StepperComponent,
		StepperLimitsComponent,
		StepperPhoneEmailComponent,
		SelectAccountComponent,
		TagMountComponent,
		TagSmallComponent,
		InputMountComponent,
		TagAccountTransferComponent,
		VoucherSuccessComponent,
		VoucherErrorComponent,
		ValidTokenComponent,
		ValidTokenEmailComponent,
		ValidTokenPhoneComponent,
		ValidTokenOnlyEmailComponent,
		ValidTokenPreferencesComponent,
		NumericDirective,
		SaveFrequentOperationComponent,
		FirtsStepComponent,
		ConfirmTransactionComponent,
		PaginatorComponent,
		TabComponent,
		TabsComponent,
		AlphanumericDirective,
		ValidMessageFormComponent,
		ProgressBarComponent,
		FloatingBarComponent,
		ProgressStepsBarComponent,
		InputNumericComponent,
		AlphaSpecialDirective,
		AlphaSpecialPasswordDirective
	],
	imports: [CommonModule, SharedFormModule, AlertModule],
	exports: [
		CommonModule,
		ToggleTabComponent,
		ButtonsReportsComponent,
		TableActionComponent,
		CardAmountComponent,
		TableBasicComponent,
		CardSingleComponent,
		StepperComponent,
		StepperLimitsComponent,
		StepperPhoneEmailComponent,
		SelectAccountComponent,
		TagMountComponent,
		TagSmallComponent,
		TagAccountTransferComponent,
		VoucherSuccessComponent,
		VoucherErrorComponent,
		InputMountComponent,
		ValidTokenComponent,
		ValidTokenEmailComponent,
		ValidTokenPhoneComponent,
		ValidTokenOnlyEmailComponent,
		ValidTokenPreferencesComponent,
		NumericDirective,
		SaveFrequentOperationComponent,
		FirtsStepComponent,
		ConfirmTransactionComponent,
		PaginatorComponent,
		TabComponent,
		TabsComponent,
		SharedFormModule,
		AlertModule,
		AlphanumericDirective,
		ValidMessageFormComponent,
		ProgressBarComponent,
		FloatingBarComponent,
		ProgressStepsBarComponent,
		InputNumericComponent,
		AlphaSpecialDirective,
		AlphaSpecialPasswordDirective
	]
})
export class SharedComponentsModule {}
